// Shared framer-motion variants + easing for the whole site.

export const EASE = [0.16, 1, 0.3, 1]; // expo-out, heavy premium feel

export const fadeUp = {
  hidden: { opacity: 0, y: 34 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 1, ease: EASE },
  },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 1.1, ease: EASE } },
};

export const stagger = (delayChildren = 0.05, staggerChildren = 0.12) => ({
  hidden: {},
  visible: {
    transition: { delayChildren, staggerChildren },
  },
});

// Kinetic line-mask reveal: inner text travels from below its clip.
export const lineMask = {
  hidden: { y: "115%" },
  visible: {
    y: "0%",
    transition: { duration: 1.15, ease: EASE },
  },
};

export const viewportOnce = { once: true, amount: 0.3 };
